import React, {useEffect} from 'react';
import {startLoader} from "../components/common/Loader";
import './test.scss';

// const LayoutEffectTest = () => {
//     const [value, setValue] = useState(0);
//
//     useEffect(() => {
//         startLoader();
//     }, [])
//
//     // useLayoutEffect(() => {
//     //     value === 0 && setValue(10 + Math.random() * 200);
//     // }, [value]);
//
//     useEffect(() => {
//         value === 0 && setValue(10 + Math.random() * 200);
//     }, [value]);
//
//     console.log('render', value);
//
//     return (
//         <div onClick={() => setValue(0)}>
//             value: {value}
//         </div>
//     );
// };

const Test = () => {
    useEffect(() => {
        startLoader();
    }, [])

    return (
        <div className='pagination'>

        </div>
    )
}

export default Test;